import * as Cesium from "cesium";
import gsap from "gsap";

/**
 * 光墙流光材质；name / tint 区分多实例不同颜色
 */
export default class LightWallMaterialProperty {
  constructor(name = "LightWallMaterial", tint = new Cesium.Color(0.8, 0.4, 1.0, 1.0)) {
    this.name = name;
    this.tint = tint;
    this.definitionChanged = new Cesium.Event();

    Cesium.Material._materialCache.addMaterial(name, {
      fabric: {
        type: name,
        uniforms: {
          uTime: 0,
          image: `${process.env.BASE_URL}texture/spriteline2.png`,
          tint: this.tint,
        },
        source: `
          czm_material czm_getMaterial(czm_materialInput materialInput)
          {
            czm_material material = czm_getDefaultMaterial(materialInput);
            vec2 st = materialInput.st;
            vec4 color = texture(image, vec2(fract(st.y + uTime), st.x));
            material.diffuse = color.rgb * tint.rgb;
            material.alpha = color.a * tint.a;
            return material;
          }
        `,
      },
      translucent: function () {
        return true;
      },
    });

    this.params = { uTime: 0 };
    gsap.to(this.params, {
      uTime: 1,
      duration: 1,
      repeat: -1,
      ease: "linear",
    });
  }

  getType() {
    return this.name;
  }

  getValue(time, result) {
    if (!result) result = {};
    result.uTime = this.params.uTime;
    result.tint = this.tint;
    return result;
  }

  equals(other) {
    return (
      other instanceof LightWallMaterialProperty && this.name === other.name
    );
  }
}
